import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { EMAIL_PATTERN } from "../../../@auth/components/constants";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Supplier } from "../../../models/supplier.model";
import { Dept, DeptDetail } from "../../../models/dept.model";
import { Finance } from "../../../models/finance.model";
import { Person } from "../../../models/person.model";
import { Catalog } from "../../../models/product.model";
import { Purchase } from "../../../models/purchase.model";
import Shop from "../../../models/shop.model";
import { CatalogService } from "../../../services/catalog.service";

import { SupplierService } from "../../../services/supplier.service";
import { FinanceService } from "../../../services/finance.service";
import { PersonService } from "../../../services/person.service";
import { PurchaseService } from "../../../services/purchase.service";

import * as moment from "moment";
import { DialogPrintDeptDetailsComponent } from "../../dialog-print-dept-details/dialog-print-dept-details.component";

@Component({
  selector: "ngx-dialog-dept-supplier-archive",
  templateUrl: "dialog-dept-supplier-archive.component.html",
  styleUrls: ["dialog-dept-supplier-archive.component.scss"],
})
export class DialogDeptSupplierArchiveComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() mode: string;
  @Input() uid: string;
  @Input() shopId: string;
  @Input() shop: Shop;
  @Input() user: User;
  @Input() supplierId: string;

  supplier: Supplier = new Supplier();
  allPurchases?: Purchase[] = [];
  purchases?: Purchase[] = [];
  exportPurchases?: Purchase[] = [];

  allDebits?: Dept[] = [];
  purchaseDebits?: Dept[] = [];
  paymentDebits?: Dept[] = [];
  deptDetail?: DeptDetail[] = [];

  periodType = "now";
  periodDate: Date = new Date();
  fromDate: Date = moment().add(-1000, "years").startOf("month").toDate();
  toDate: Date = moment().add(1000, "years").endOf("month").toDate();
  selectedTime: any = null;

  purchaseCount = 0;
  purchaseSubs: any;
  source: LocalDataSource = new LocalDataSource();

  saleAmount = 0;
  paidAmount = 0;
  debitAmount = 0;
  discountAmount = 0;
  isDetail = false;

  //display filter by date
  initAmount = 0;
  displaySaleAmount = 0;
  displayPaidAmount = 0;
  displayDebitAmount = 0;
  displayDiscountAmount = 0;
  displayDebits?: Dept[] = [];
  displayDeptDetail?: DeptDetail[] = [];
  displayPaymentDebits?: Dept[] = [];

  submitted = false;
  loading = false;
  changeData = false;

  constructor(
    protected ref: NbDialogRef<DialogDeptSupplierArchiveComponent>,
    private userService: UserService,
    private purchaseService: PurchaseService,
    private fb: FormBuilder,
    private supplierService: SupplierService,
    private catalogService: CatalogService,
    private personService: PersonService,
    private financeService: FinanceService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.supplierService
      .getSupplier(this.shopId, this.supplierId)
      .then((doc) => {
        console.log("CustomerComponent/getCustomer:", doc.data());

        if (doc.exists) {
          this.supplier = doc.data();
          this.supplier.id = this.supplierId;
          this.supplier.createdOn = convertTimestamp(doc.data().createdOn);

          this.saleAmount = this.supplier.saleAmount;
          this.paidAmount = this.supplier.paidAmount;
          this.debitAmount = this.supplier.debitAmount;

          this.getPurchases();
        } else {
          this.supplier.id = "";
        }

        this.loading = false;
      })
      .catch((err) => {
        console.log("CustomerComponent/getCustomer/err:", err);
        this.supplier.id = "";
        this.loading = false;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.ref.close(this.supplier);
  }

  print() {
    this.dialogService
      .open(DialogPrintDeptDetailsComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          object: this.supplier,
          mode: "supplier",
          fromDate: this.periodType === "now" ? null : this.fromDate,
          toDate: this.periodType === "now" ? null : this.toDate,
          deptDetail: this.displayDeptDetail,
          paymentDebits: this.displayPaymentDebits,
          initAmount: this.initAmount,
          saleAmount: this.displaySaleAmount,
          paidAmount: this.displayPaidAmount,
          debitAmount: this.displayDebitAmount,
          discountAmount: this.displayDiscountAmount,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  exportAsXLSX() {
    this.dialogService
      .open(DialogPrintDeptDetailsComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          object: this.supplier,
          mode: "supplier",
          type: "export",
          fromDate: this.periodType === "now" ? null : this.fromDate,
          toDate: this.periodType === "now" ? null : this.toDate,
          deptDetail: this.displayDeptDetail,
          paymentDebits: this.displayPaymentDebits,
          initAmount: this.initAmount,
          saleAmount: this.displaySaleAmount,
          paidAmount: this.displayPaidAmount,
          debitAmount: this.displayDebitAmount,
          discountAmount: this.displayDiscountAmount,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  selectTime(value) {
    this.selectedTime = value;

    if (!value || value.type === "now") {
      this.fromDate = null;
      this.toDate = null;

      this.initAmount = 0;
      this.displaySaleAmount = this.saleAmount;
      this.displayPaidAmount = this.paidAmount;
      this.displayDebitAmount = this.debitAmount;
      this.displayDiscountAmount = this.discountAmount;
      this.displayDebits = [...this.allDebits];
      this.displayDeptDetail = [...this.deptDetail];
      this.displayPaymentDebits = [...this.paymentDebits];
    } else {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.type;

      //filter by time
      this.initAmount = 0;
      this.displaySaleAmount = 0;
      this.displayPaidAmount = 0;
      this.displayDebitAmount = 0;
      this.displayDiscountAmount = 0;
      this.displayDebits = [];
      this.displayDeptDetail = [];
      this.displayPaymentDebits = [];

      let initSaleAmount = 0;
      let initPaidAmount = 0;
      const fromTimestamp = this.fromDate.getTime();
      const toTimestamp = this.toDate.getTime();
      console.log("fromTimestamp:", fromTimestamp);
      console.log("toTimestamp:", toTimestamp);

      _.forEach(this.allDebits, (debit) => {
        if (debit.timestamp < fromTimestamp) {
          initSaleAmount += debit.amount;
          initPaidAmount += debit.paid;
        } else if (debit.timestamp <= toTimestamp) {
          this.displaySaleAmount += debit.amount;
          this.displayPaidAmount += debit.paid;

          if (debit.receipt && debit.receipt.totalDiscountAmount != 0) {
            this.displayDiscountAmount += debit.receipt.totalDiscountAmount;
          }

          this.displayDebits.push(debit);

          if (debit.deptDetails) {
            this.displayDeptDetail = [
              ...this.displayDeptDetail,
              ...debit.deptDetails,
            ];
          }

          if (debit.mode === "payment") {
            this.displayPaymentDebits.push(debit);
          }
        }
      });
      this.initAmount = initSaleAmount - initPaidAmount;
      this.displayDebitAmount =
        this.initAmount + this.displaySaleAmount - this.displayPaidAmount;
    }

    console.log("selectedTime:", this.selectedTime);
  }

  //Load data

  private getPurchases() {
    this.loading = true;
    this.purchaseService
      .getPurchaseTradesBySupplier(
        this.shopId,
        this.supplier.id,
        this.fromDate,
        this.toDate
      )
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          this.purchases = data;
          this.summaryPurchase();
          console.log("getPurchases:", this.purchases);

          this.loading = false;
        },
        (err) => {
          this.purchases = [];
          this.summaryPurchase();
          this.loading = false;
          console.log("getPurchases/err:", err);
        }
      );
  }

  private summaryPurchase() {
    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;

    this.purchaseDebits = [];
    this.deptDetail = [];

    _.forEach(this.purchases, (item) => {
      let expData: Dept = new Dept();
      expData.id = item.id;
      expData.issueDate = item.issueDate;
      expData.code = item.id.substring(item.id.length - 6, item.id.length);
      expData.note = item.note;
      expData.amount = item.totalAmount;
      expData.paid = 0;
      expData.debit = 0;
      expData.mode = "purchase";
      expData.timestamp = item.issueDate.getTime();
      expData.purchase = item;

      //add detail
      let deptDetails: DeptDetail[] = [];
      _.forEach(item.purchaseDetails, (itemD) => {
        let detail: DeptDetail = new DeptDetail();
        detail.issueDate = item.issueDate;
        detail.code = item.id.substring(item.id.length - 6, item.id.length);
        detail.note = item.note;

        detail.productId = itemD.productId;
        detail.productCode = itemD.productCode;
        detail.productName = itemD.productName;
        detail.productDescription = itemD.productDescription;
        detail.productUnitName = itemD.productUnitName;
        detail.discountPercent = itemD.discountPercent;
        detail.discountAmount = itemD.discountAmount;
        detail.quantity = itemD.quantity;
        detail.price = itemD.price;
        detail.amount = itemD.amount;
        detail.netAmount = itemD.netAmount;
        detail.comment = itemD.comment;
        detail.timestamp = item.issueDate.getTime();
        this.deptDetail.push(detail);
        deptDetails.push(detail);
      });
      expData.deptDetails = deptDetails;
      this.purchaseDebits.push(expData);
    });

    //Get finances
    this.getFinances();
  }

  getFinances() {
    this.loading = true;
    this.financeService
      .getFinancesBySupplier(
        this.shopId,
        this.supplier.id,
        this.fromDate,
        this.toDate
      )
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        console.log("getFinances:", data);

        this.paymentDebits = [];
        _.forEach(data, (item) => {
          let expData: Dept = new Dept();
          expData.id = item.id;
          expData.issueDate = item.issueDate;
          expData.code = item.id.substring(item.id.length - 6, item.id.length);
          expData.note = item.note;
          expData.amount = item.isReceive ? item.receiveAmount : 0;
          expData.paid = !item.isReceive ? item.issueAmount : 0;
          expData.debit = 0;
          expData.mode = "payment";
          expData.timestamp = item.issueDate.getTime();
          expData.payment = item;

          this.paymentDebits.push(expData);
        });

        this.calculateDept();

        this.loading = false;
      });
  }

  private calculateDept() {
    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;

    let depts: Dept[] = [...this.purchaseDebits, ...this.paymentDebits];
    depts = _.sortBy(depts, ["issueDate"]);

    this.allDebits = [];
    _.forEach(depts, (item) => {
      let expData: Dept = new Dept();
      expData = item;
      expData.debit = this.debitAmount + (item.amount - item.paid);

      this.allDebits.push(expData);

      this.saleAmount += item.amount;
      this.paidAmount += item.paid;
      this.debitAmount = expData.debit;

      if (item.purchase && item.purchase.totalDiscountAmount != 0) {
        this.discountAmount += item.purchase.totalDiscountAmount;
      }
    });

    this.selectTime(this.selectedTime);
  }
}
